var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',[_c('div',{staticClass:"list-item new-folder"},[_c('Icon',{attrs:{"name":"more-arrow","size":"16px"}}),_c('input',{staticClass:"title-input",attrs:{"type":"text"},on:{"keydown":_vm.newFolderKeyDown}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }